import { MantineBreakpoint } from "@mantine/core";

import { ISidebarNavItem } from "./app-shell.models";

export const SIDEBAR_NAV_ITEMS: ISidebarNavItem[] = [
  { to: "/", labelKey: "shell.dashboard", end: true },
  { to: "/registers", labelKey: "shell.registers", end: true },
  { to: "/business-units", labelKey: "shell.businessUnits", end: true },
];

export const HEADER_HEIGHT = 64;

export const NAVBAR_WIDTH = 256;

/** Below this the navbar is a burger menu; above it, a permanent sidebar. */
export const NAVBAR_BREAKPOINT: MantineBreakpoint = "lg";
